import MasterDataBase from './MasterDataBase';

export { MasterDataBase };
